import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, lightTheme } from '@vgrubs/components';
import { BrowserRouter } from 'react-router-dom';
// Deep import on purpose: the module reaches for `virtual:pwa-register`,
// which only exists in builds that load vite-plugin-pwa - it must never be
// re-exported through the `@vgrubs/components` barrel.
import { registerAppSw } from 'components/src/pwa/registerAppSw';
import 'leaflet/dist/leaflet.css';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider theme={lightTheme}>
    <GlobalStyles />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
);

registerAppSw();
